import React, { useState, useEffect } from 'react'
import './styles.scss';
import { useSelector, useDispatch } from "react-redux";
import SubHeader from '../../components/Header/subHeader'
import { Button, Input, Form, FormGroup } from 'reactstrap';
import LoadingButton from '../../components/LoadingButton'
import { postWaitingRoomChannelHeader ,updateWaitingRoomChannelName, updateWaitingRoomChannelNameRequest } from '../../store/actions/taskAction';
import { history } from '..';
const WaitingRoomHeader = () => {
    const states = useSelector((state) => state.task);
    const [practice_name, setName] = useState(states.managewaitingRoomMediaChannel.practice_name);
    const bgImg = 'assets/img/bg.png'
    const dispatch = useDispatch();
    const changeHandler = (field, value) => {

        setSaveMessage({
            message: "SAVE PRACTICE NAME",
            bgColor: "primary",
        });
        setName({
            practice_name:value
        })
        // let managewaitingRoomMediaChannel = states.managewaitingRoomMediaChannel
        // managewaitingRoomMediaChannel[field] = value
        // managewaitingRoomMediaChannel['enableButton'] = false
        // dispatch(updateWaitingRoomChannelNameRequest(managewaitingRoomMediaChannel))
    }
    
    const [saveMessage, setSaveMessage] = useState({
        message: "SAVE PRACTICE NAME",
        bgColor: "primary",
    });

    
    

    useEffect(() => {
        setName({
            practice_name:states.managewaitingRoomMediaChannel.practice_name
        })
    },[states.managewaitingRoomMediaChannel])
    
    const handleSubmit = (event) => {

        let params ={
            practice_name:practice_name.practice_name
        }

        dispatch(updateWaitingRoomChannelName(states.managewaitingRoomMediaChannel.id , params))

        setSaveMessage({
            message: "Changes saved",
            bgColor: "green",
        });

        setTimeout(() => { 
            history.goBack()
        }, 2000)
    }
    return (
        <div className="main__screen channels__page  d-flex flex-column h-100 align-items-center justify-content-center">
            <SubHeader className="mb-auto" title="Header"/>
            <div className="waiting-room-header">
                <div className="header-left-side">
                <div className="Page4__main__div1">
                    <div className="row  Page4__main__div1__row">

                        <div className="Page4__main__div1__row__upperDiv">
                            <h1>Practice name</h1>
                            <p>Enter the practice name to be displayed</p>
                            <Form>
                                <FormGroup>
                                    <Input placeholder="" onChange={(e)=> changeHandler('practice_name' , e.target.value)} value={`${practice_name.practice_name}`} />
                                </FormGroup>
                                <FormGroup>
                                    {/* <Button color="primary" type="button" onClick={handleSubmit} className=""> {saveMessage.message} </Button> */}
                                    <LoadingButton type="button"  label={saveMessage.message} loading={states.buttonLoading2} disabled={states.buttonLoading2 || states.managewaitingRoomMediaChannel.practice_name.length <= 0} size="xxl" onClick={handleSubmit} className={`mt-auto w-100`}  color={saveMessage.bgColor}/>
                                </FormGroup>
                            </Form>
                        </div>
                    </div>
                </div>
                </div>
                <div className="header-right-side">
                    <div className="Page4__main__div2">
                        <img src={bgImg} alt=""></img>
                        <label>{ practice_name.practice_name }</label>
                    </div>
                </div>                     
            </div>
        </div>
    )
}

export default WaitingRoomHeader;
